<div class="buttons-box">
  <div *ngFor="let offset of columnOffsetList"
       class="wrapper-button"
       [ngStyle]="{ 'left': offset.left + 'px', 'width': offset.width  + 'px'}">
    <button class="header-button">{{'column key: ' + offset.key}}</button>
  </div>
</div>

<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
  (columnOffsets)="changeColumnOffsets($event)"
></aur-mat-table>
